import { SET_CRM_LEVEL_INFO_ACTION } from "../actions/InfoLoyaltyPageAction/actionTypes";

const initialState = {
	dataInfoLoyalty: {}
};

const infoLoyaltyPageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CRM_LEVEL_INFO_ACTION: {
			return {
				...state,
				dataInfoLoyalty: action.params
			};
		}

		default:
			return state;
	}
};

export default infoLoyaltyPageReducer;
